// extracted by mini-css-extract-plugin
export default {"PromoBanner":"PromoBanner_PromoBanner__Kq+uc","Icon":"PromoBanner_Icon__bVpGB","PromoCopy":"PromoBanner_PromoCopy__XjXMK"};